// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PaychecksSetUpDirectDepositStartEvent
 */
export var PaychecksSetUpDirectDepositStart = function (_a) {
    var hasDistributionSet = _a.hasDistributionSet, source = _a.source;
    return ({
        name: "Paychecks SetUpDirectDeposit Start",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "SetUpDirectDeposit",
            has_distribution_set: hasDistributionSet !== undefined && hasDistributionSet !== null ? hasDistributionSet.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksSetUpDirectDepositAlreadySetUpEvent
 */
export var PaychecksSetUpDirectDepositAlreadySetUp = function () { return ({
    name: "Paychecks SetUpDirectDeposit AlreadySetUp",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "SetUpDirectDeposit",
    }
}); };
/**
 * @see PaychecksShowFullHistoryEvent
 */
export var PaychecksShowFullHistory = function () { return ({
    name: "Paychecks Show FullHistory",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "Show",
    }
}); };
/**
 * @see PaychecksShowMonthlyAggregatePaycheckReceiptEvent
 */
export var PaychecksShowMonthlyAggregatePaycheckReceipt = function (_a) {
    var monthInYear = _a.monthInYear, year = _a.year, isCurrentMonth = _a.isCurrentMonth;
    return ({
        name: "Paychecks Show MonthlyAggregatePaycheckReceipt",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "Show",
            month_in_year: monthInYear !== undefined && monthInYear !== null ? monthInYear.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            year: year !== undefined && year !== null ? year.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_current_month: isCurrentMonth !== undefined && isCurrentMonth !== null ? isCurrentMonth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksShowPaycheckReceiptEvent
 */
export var PaychecksShowPaycheckReceipt = function (_a) {
    var paycheckToken = _a.paycheckToken, fromViewAll = _a.fromViewAll;
    return ({
        name: "Paychecks Show PaycheckReceipt",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "Show",
            paycheck_token: paycheckToken !== undefined && paycheckToken !== null ? paycheckToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            from_view_all: fromViewAll !== undefined && fromViewAll !== null ? fromViewAll.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksShowBenefitsHubEvent
 */
export var PaychecksShowBenefitsHub = function (_a) {
    var benefitsStatus = _a.benefitsStatus;
    return ({
        name: "Paychecks Show BenefitsHub",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "Show",
            benefits_status: benefitsStatus !== undefined && benefitsStatus !== null ? benefitsStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksDismissPaycheckReceiptEvent
 */
export var PaychecksDismissPaycheckReceipt = function () { return ({
    name: "Paychecks Dismiss PaycheckReceipt",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "Dismiss",
    }
}); };
/**
 * @see PaychecksManageDistributionConfirmEditAllocationEvent
 */
export var PaychecksManageDistributionConfirmEditAllocation = function (_a) {
    var flowToken = _a.flowToken, destinationType = _a.destinationType, amountInBps = _a.amountInBps;
    return ({
        name: "Paychecks ManageDistribution ConfirmEditAllocation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_in_bps: amountInBps !== undefined && amountInBps !== null ? amountInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionConfirmSetAllocationEvent
 */
export var PaychecksManageDistributionConfirmSetAllocation = function (_a) {
    var flowToken = _a.flowToken, destinationType = _a.destinationType, amountInBps = _a.amountInBps;
    return ({
        name: "Paychecks ManageDistribution ConfirmSetAllocation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_in_bps: amountInBps !== undefined && amountInBps !== null ? amountInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionEditConfigurationRowTappedEvent
 */
export var PaychecksManageDistributionEditConfigurationRowTapped = function (_a) {
    var flowToken = _a.flowToken, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution EditConfigurationRowTapped",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionEditDistributionDoneEvent
 */
export var PaychecksManageDistributionEditDistributionDone = function () { return ({
    name: "Paychecks ManageDistribution EditDistributionDone",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "ManageDistribution",
    }
}); };
/**
 * @see PaychecksManageDistributionEditDistributionShowHelpEvent
 */
export var PaychecksManageDistributionEditDistributionShowHelp = function () { return ({
    name: "Paychecks ManageDistribution EditDistributionShowHelp",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "ManageDistribution",
    }
}); };
/**
 * @see PaychecksManageDistributionEditDistributionStartEvent
 */
export var PaychecksManageDistributionEditDistributionStart = function () { return ({
    name: "Paychecks ManageDistribution EditDistributionStart",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "ManageDistribution",
    }
}); };
/**
 * @see PaychecksManageDistributionGetStartedEvent
 */
export var PaychecksManageDistributionGetStarted = function () { return ({
    name: "Paychecks ManageDistribution GetStarted",
    parameters: {
        cdf_entity: "Paychecks",
        cdf_action: "ManageDistribution",
    }
}); };
/**
 * @see PaychecksManageDistributionStartEditAllocationEvent
 */
export var PaychecksManageDistributionStartEditAllocation = function (_a) {
    var destinationType = _a.destinationType, updatingExistingAllocation = _a.updatingExistingAllocation;
    return ({
        name: "Paychecks ManageDistribution StartEditAllocation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            updating_existing_allocation: updatingExistingAllocation !== undefined && updatingExistingAllocation !== null ? updatingExistingAllocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionStartEditAllocationFlowEvent
 */
export var PaychecksManageDistributionStartEditAllocationFlow = function (_a) {
    var flowToken = _a.flowToken, destinationType = _a.destinationType, updatingExistingAllocation = _a.updatingExistingAllocation;
    return ({
        name: "Paychecks ManageDistribution StartEditAllocationFlow",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            updating_existing_allocation: updatingExistingAllocation !== undefined && updatingExistingAllocation !== null ? updatingExistingAllocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionSetAllocationAmountWithATMButtonEvent
 */
export var PaychecksManageDistributionSetAllocationAmountWithATMButton = function (_a) {
    var flowToken = _a.flowToken, amountInBps = _a.amountInBps, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution SetAllocationAmountWithATMButton",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_in_bps: amountInBps !== undefined && amountInBps !== null ? amountInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionSetAllocationAmountWithWheelDragEvent
 */
export var PaychecksManageDistributionSetAllocationAmountWithWheelDrag = function (_a) {
    var flowToken = _a.flowToken, amountInBps = _a.amountInBps, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution SetAllocationAmountWithWheelDrag",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_in_bps: amountInBps !== undefined && amountInBps !== null ? amountInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionSetAllocationAmountWithKeypadEvent
 */
export var PaychecksManageDistributionSetAllocationAmountWithKeypad = function (_a) {
    var flowToken = _a.flowToken, amountInBps = _a.amountInBps, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution SetAllocationAmountWithKeypad",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_in_bps: amountInBps !== undefined && amountInBps !== null ? amountInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionSetAllocationAmountWarnForOverallocationEvent
 */
export var PaychecksManageDistributionSetAllocationAmountWarnForOverallocation = function (_a) {
    var flowToken = _a.flowToken, attemptedAmountInBps = _a.attemptedAmountInBps, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution SetAllocationAmountWarnForOverallocation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempted_amount_in_bps: attemptedAmountInBps !== undefined && attemptedAmountInBps !== null ? attemptedAmountInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionTurnOffAllocationEvent
 */
export var PaychecksManageDistributionTurnOffAllocation = function (_a) {
    var flowToken = _a.flowToken, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution TurnOffAllocation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionTurnOffAllocationConfirmationEvent
 */
export var PaychecksManageDistributionTurnOffAllocationConfirmation = function (_a) {
    var flowToken = _a.flowToken, destinationType = _a.destinationType;
    return ({
        name: "Paychecks ManageDistribution TurnOffAllocationConfirmation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_type: destinationType !== undefined && destinationType !== null ? destinationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaychecksManageDistributionSubmitMultiAllocationEvent
 */
export var PaychecksManageDistributionSubmitMultiAllocation = function (_a) {
    var flowToken = _a.flowToken, totalAllocationInBps = _a.totalAllocationInBps, estimatedMonthlyAmount = _a.estimatedMonthlyAmount, estimatedMonthlyAmountCurrency = _a.estimatedMonthlyAmountCurrency, allocationsInBps = _a.allocationsInBps, allocationsDisplayNames = _a.allocationsDisplayNames;
    return ({
        name: "Paychecks ManageDistribution SubmitMultiAllocation",
        parameters: {
            cdf_entity: "Paychecks",
            cdf_action: "ManageDistribution",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            total_allocation_in_bps: totalAllocationInBps !== undefined && totalAllocationInBps !== null ? totalAllocationInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            estimated_monthly_amount: estimatedMonthlyAmount !== undefined && estimatedMonthlyAmount !== null ? estimatedMonthlyAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            estimated_monthly_amount_currency: estimatedMonthlyAmountCurrency !== undefined && estimatedMonthlyAmountCurrency !== null ? estimatedMonthlyAmountCurrency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            allocations_in_bps: allocationsInBps !== undefined && allocationsInBps !== null ? allocationsInBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            allocations_display_names: allocationsDisplayNames !== undefined && allocationsDisplayNames !== null ? allocationsDisplayNames.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
